import React, { useState, Fragment } from 'react';
import {
  Row,
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CustomInput,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import { AxiosAPI } from '../../../../../../helpers/AxiosAPI';
import { putAPI_Update_Contacts } from '../../../../../../constants/APIs';
import Validation from '../../../../../../components/Validation';
import IntlMessages from '../../../../../../helpers/IntlMessages';
export default function ContactsForm({ contacts, id, name, visible, toggle }) {
  const [inputFields, setInputFields] = useState(contacts.filter(x => x.type !== "DailyTickets" && x.type !== "WeeklyTickets" && x.type !== "MonthlyTickets"));
  const [allContacts, setAllContacts] = useState(contacts.filter(x => x.type === "DailyTickets" || x.type === "WeeklyTickets" || x.type === "MonthlyTickets"));
  const [isEditing, setIsEditing] = useState(false);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const handleAddFields = () => {
    const values = [...inputFields];
    values.push({
      type: 'DailyAnalytics',
      name: '',
      email: '',
      phoneNumber: '',
      isBcc: false,
    });
    setInputFields(values);
    setIsEditing(true);
  };

  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
    setIsEditing(true);
  };

  const handleInputChange = (index, event) => {
    const values = [...inputFields];
    if (event.target.name === 'name') {
      values[index].name = event.target.value;
    } else if (event.target.name === 'email') {
      values[index].email = event.target.value;
    }
    //  else if (event.target.name === 'phoneNumber') {
    //   values[index].phoneNumber = event.target.value;
    // } 
    else {
      values[index].type = event.target.value;
    }

    setInputFields(values);
    setIsEditing(true);
  };

  const handleCheckChange = (index, e) => {
    const values = [...inputFields];
    if (e.target.checked) {
      values[index].isBcc = true;
    } else {
      values[index].isBcc = false;
    }
    setInputFields(values);
    setIsEditing(true);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const data = { contacts: [...inputFields, ...allContacts], updater: 'admin' };
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_Contacts}/${id}`,
      data,
    }).then(
      (res) => {
        console.log(461, res.data)
        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
          && res.data.Messages !== null && res.data.Messages.length > 0) {
          setMsg(res.data.Messages);
          setOpen(true);
        }
        else {
          setTimeout(() => {
            NotificationManager.success(
              '',
              'Contacts updated successfully.',
              3000,
              null,
              null,
              'success'
            );
            window.location.reload();
          }, 300);
        }
      });
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} size="xl">
        <ModalHeader>Edit {name} Contacts</ModalHeader>
        <ModalBody>
          <Row>
            {inputFields != null &&
              inputFields.map((contact, index) => (
                <Fragment key={index}>
                  <Colxx sm={4} className="md-3">
                    <Label>Type</Label>
                    <Input
                      type="select"
                      value={contact.type}
                      name="type"
                      onChange={(event) => handleInputChange(index, event)}
                    >
                      {/* <option value="NewTickets">Booking Desk Tickets</option>
                      <option value="Conference">Conference Enquiries</option> */}
                      <option value="DailyAnalytics">Daily Analytics</option>
                      {/* <option value="FrontDeskTickets">
                        Front Desk Tickets
                      </option>
                      <option value="GroupBooking">Group Booking</option>
                      <option value="LongStay">Long Stay</option>
                      <option value="MissingResponses">
                        Missing Responses
                      </option>
                     
                      <option value="Reservations">Reservations</option> */}
                      <option value="WeeklyAnalytics">Weekly Analytics</option>
                      <option value="MonthlyAnalytics">
                        Monthly Analytics
                      </option>

                      {/* <option value="FoodBeverage">Food & Beverage</option> */}
                    </Input>
                  </Colxx>
                  <Colxx sm={3} className="mb-3">
                    <Label>Name</Label>
                    <Input
                      type="text"
                      name="name"
                      value={contact.name}
                      onChange={(event) => handleInputChange(index, event)}
                    />
                  </Colxx>
                  <Colxx sm={3} className="mb-3">
                    <Label>Email</Label>
                    <Input
                      type="text"
                      name="email"
                      min={1}
                      value={contact.email}
                      onChange={(event) => handleInputChange(index, event)}
                    />
                  </Colxx>
                  {/* <Colxx sm={2} className="mb-3">
                    <Label>Phone Number</Label>
                    <Input
                      type="text"
                      name="phoneNumber"
                      min={1}
                      value={contact.phoneNumber}
                      onChange={(event) => handleInputChange(index, event)}
                    />
                  </Colxx> */}
                  <Colxx sm={1} className="mb-3">
                    <Label>BCC</Label>
                    <CustomInput
                      type="checkbox"
                      id={index}
                      defaultChecked={contact.isBcc}
                      name="isBcc"
                      onChange={(event) => handleCheckChange(index, event)}
                    />
                  </Colxx>

                  <Colxx sm={1} className="mb-3">
                    <Label>Remove</Label>
                    <div>
                      <Button
                        onClick={() => handleRemoveFields(index)}
                        color="secondary"
                        size="xs"
                        outline
                        style={{ margin: '6px' }}
                      >
                        -
                      </Button>
                    </div>
                  </Colxx>
                </Fragment>
              ))}
          </Row>
          <Button
            onClick={handleAddFields}
            color="primary"
            size="xs"
            outline
            style={{ margin: '6px' }}
          >
            + Add Contact
          </Button>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            Save Contacts
          </Button>
          <Button color="secondary" onClick={toggle}>
            <IntlMessages id='pages.cancel' />
          </Button>
        </ModalFooter>
      </Modal>
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </Fragment>
  );
}
